import * as React from "react";
import Header from "./components/Header";
import styles from "./styles/App.module.css"
import UnstyledTabsCustomized from "./components/Tabs";
import {applyFilters, regenerateData, sortAndGroupEvents} from "./utils";
import {Modal} from "@mui/base";
import Footer from "./components/Footer";
import { Routes, Route } from 'react-router-dom';
import EventDetails from "./components/EventDetails";
import NavigationIcon from "@mui/icons-material/Navigation";
import {Button, Box, Fab, ThemeProvider, createTheme} from "@mui/material";

const sortedEvents = sortAndGroupEvents();
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 1080,
            lg: 1200,
            xl: 1536,
        },
    },
});

function App() {
    const [open, setOpen] = React.useState(false);
    const [locationCords, setLocationCords] = React.useState("");
    const [filteredEvents, setFilteredEvents] = React.useState(sortedEvents);
    const mainEventsRef = React.useRef(null);

    const handleClose = () => setOpen(false);
    const handleFilters = React.useCallback((filters) => {
        let temp = {};
        temp.upcoming = applyFilters(sortedEvents.upcoming, filters);
        temp.past = applyFilters(sortedEvents.past, filters);
        setFilteredEvents(temp);
    }, []);
    const handleLocationClick = React.useCallback((location) => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        if (regex.test(userAgent)) {
            // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${cords}`);
            window.open(location.googleMap,'_self');
        } else {
            window.open(location.googleMap);
            // window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${cords}`);
        }
    }, []);
    const scrollToMain = React.useCallback(() => mainEventsRef.current.scrollIntoView({behavior: 'smooth'}), []) ;

    React.useEffect(() => {
        regenerateData(false);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <div ref={mainEventsRef}>
                <Header />
            </div>
            <Routes>
                {/* <Route path="/" element={<UnstyledTabsCustomized events={filteredEvents} applyFilters={handleFilters} showLocation={handleLocationClick} />} /> */}
                <Route path="/events" element={<UnstyledTabsCustomized events={filteredEvents} applyFilters={handleFilters} showLocation={handleLocationClick} />} />
                <Route path="/events/:id" element={<EventDetails showLocation={handleLocationClick} />} />
            </Routes>
            {/* <Fab
                variant="extended"
                size="small"
                color="primary"
                style={{position: "fixed", bottom: 20, right: 20}}
                onClick={scrollToMain}
            >
                <NavigationIcon sx={{ mr: 1 }} />
                Scroll to Top
            </Fab> */}
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{bgcolor: 'background.paper'}} className={styles.googleMapsContainer}>
                    <iframe
                        allowFullScreen
                        height="100%"
                        loading="lazy"
                        title="Map"
                        referrerPolicy="no-referrer-when-downgrade"
                        width="100%"
                        style={{border: "none"}}
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCt03432U7RTOmq3Rebe-RY6midF6205yk&q=${locationCords}`}>
                    </iframe>
                    <br/>
                    <div style={{textAlign: "center", backgroundColor: "white", outline: "none"}}>
                        <Button onClick={handleClose}>Close</Button>
                    </div>
                </Box>
            </Modal>
            <Footer />
        </ThemeProvider>
    );
}

export default App;
